export default function(data) {
var __t, __p = '';
__p += '<div class="well row no-alerts">\n  ' +
((__t = ( data.brokenBellSVG() )) == null ? '' : __t) +
'\n  <p>\n    There are currently no deals that match this alert.\n  </p>\n</div>\n';
return __p
}